"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "SidebarTab", {
  enumerable: true,
  get: function get() {
    return _SidebarTab.default;
  }
});
Object.defineProperty(exports, "Tab", {
  enumerable: true,
  get: function get() {
    return _Tab.default;
  }
});
Object.defineProperty(exports, "Tablist", {
  enumerable: true,
  get: function get() {
    return _Tablist.default;
  }
});
Object.defineProperty(exports, "TabNavigation", {
  enumerable: true,
  get: function get() {
    return _TabNavigation.default;
  }
});

var _SidebarTab = _interopRequireDefault(require("./src/SidebarTab"));

var _Tab = _interopRequireDefault(require("./src/Tab"));

var _Tablist = _interopRequireDefault(require("./src/Tablist"));

var _TabNavigation = _interopRequireDefault(require("./src/TabNavigation"));
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy90YWJzL2luZGV4LmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQUE7O0FBQ0E7O0FBQ0E7O0FBQ0EiLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgeyBkZWZhdWx0IGFzIFNpZGViYXJUYWIgfSBmcm9tICcuL3NyYy9TaWRlYmFyVGFiJ1xuZXhwb3J0IHsgZGVmYXVsdCBhcyBUYWIgfSBmcm9tICcuL3NyYy9UYWInXG5leHBvcnQgeyBkZWZhdWx0IGFzIFRhYmxpc3QgfSBmcm9tICcuL3NyYy9UYWJsaXN0J1xuZXhwb3J0IHsgZGVmYXVsdCBhcyBUYWJOYXZpZ2F0aW9uIH0gZnJvbSAnLi9zcmMvVGFiTmF2aWdhdGlvbidcbiJdfQ==


//////////////////
// WEBPACK FOOTER
// ./~/evergreen-ui/commonjs/tabs/index.js
// module id = 208
// module chunks = 0